export const FEATURE_FLAGS = {
    exampleFeed: true,
    downloadButton: false,
}
